<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../../_common/z/ztab.svelte'
    import ScheduleConfigSchedulers from './schedule-config-schedulers.svelte'
    import ScheduleConfigGoogleV2 from './schedule-config-google-v2.svelte'

    let tabs = [
        {
            title: 'Agendas',
            url: '/tools-scheduler/registration',
        },
        {
            title: 'Integração',
            url: '/tools-scheduler/integration-v2',
        },
    ]
</script>

<div class="limit-1600">
    <Ztab class="h-space" {tabs} />
    <Router>
        <Route path="/registration">
            <div>
                <ScheduleConfigSchedulers />
            </div>
        </Route>
        <Route path="/integration-v2">
            <ScheduleConfigGoogleV2 />
        </Route>
    </Router>

    <div class="m-bottom-sm" />
</div>
